<script setup>
import { useI18n } from 'vue-i18n'
import { Textarea } from '@drama/ui'
import FormField from '../NovelFormField.vue'
import { useSectionModel } from './section-model.js'
import './novel-sections.css'
const props = defineProps({ modelValue: { type: Object, required: true }, issues: { type: Array, default: () => [] } })
const emit = defineEmits(['update:modelValue', 'blocked'])
const { t } = useI18n()
const { bind, error } = useSectionModel(props, emit)
</script>
<template>
  <section
    class="novel-entity"
    data-testid="novel-world-group"
  >
    <FormField
      :error="error(['world_rules'])"
      required
      :label="t('novelStudio.fields.worldRules')"
      :hint="t('novelStudio.fields.worldRulesHint')"
    >
      <Textarea
        v-bind="bind(['world_rules'])"
        :rows="6"
      />
    </FormField>
  </section>
</template>
